export const KEYS_ENUMS = {
    ACCESS_TOKEN: "userAccessToken",
    REFRESH_TOKEN: "userRefreshToken",
}